// extracted by mini-css-extract-plugin
export var legendIndicator = "_f3-1";
export var legendRight = "_f3-0";